import { useEffect, useRef } from 'react';

import { trackOperation } from 'events/ops/opsEvent';
import type { UserOperation } from 'events/ops/opsEvent';

/**
 * Emits a render success ops event exactly once on first mount.
 * Accepting undefined as a valid prop to skip ops event emission from modal components
 * which are loaded into the DOM before they into view via a user operation.
 * uses the showModal prop in those modal components to control the component render success ops event
 * to fire only when the modal is actually shown to the user.
 */
const useTrackComponentRenderSuccess = (operation: UserOperation | undefined): void => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (operation && !hasTracked.current) {
      hasTracked.current = true;
      trackOperation(operation, 'success');
    }
  }, [operation]);
};

export default useTrackComponentRenderSuccess;
